import './globalAnimations';
import './TextAnimation';
